module.exports = __webpack_public_path__ + "img/cpu.09ad6104.svg";